var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    fill: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v600H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E00",
    strokeWidth: 120,
    d: "M0 60h900m0 240H0m0 240h900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0050F0",
    d: "M0 0v600l520-300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m114 382 59-183 59 183L77 269h192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.a44e9537325c1a5478bb4a878ca97d1b.svg";
export { ForwardRef as ReactComponent };